import {
  LayoutDashboard,
  Car,
  UserCog,
  Shield,
  Building2,
  Route,
  CalendarClock,
  BarChart3,
  FileText,
  Star,
  Settings,
  MapPin,
  Package,
  PackagePlus,
  Wrench,
  PackageCheck,
} from 'lucide-react';

/**
 * Fonte única do menu lateral. Cada item tem permissão própria
 * para aparecer na tela de Funções e poder ser concedido.
 */
export const NAV_ITEMS = [
  { name: 'Dashboard', href: '/', icon: LayoutDashboard, permission: 'dashboard', section: 'Operação' },
  { name: 'Rotas', href: '/rotas', icon: Route, permission: 'rotas', section: 'Operação' },
  { name: 'Preventivas', href: '/preventivas', icon: CalendarClock, permission: 'preventivas', section: 'Operação' },
  { name: 'Mapa Técnicos', href: '/mapa-tecnicos', icon: MapPin, permission: 'mapa_tecnicos', section: 'Operação' },
  { name: 'Clientes', href: '/clientes', icon: Building2, permission: 'clientes', section: 'Cadastros' },
  { name: 'Carros', href: '/carros', icon: Car, permission: 'carros', section: 'Cadastros' },
  { name: 'Tipos de serviço', href: '/tipos-servico-rota', icon: Wrench, permission: 'tipos_servico_rota', section: 'Cadastros' },
  { name: 'Estoque', href: '/estoque', icon: Package, permission: 'estoque', section: 'Estoque' },
  { name: 'Requisições', href: '/reposicoes', icon: PackageCheck, permission: 'reposicoes', section: 'Estoque' },
  { name: 'Complementos', href: '/complementos-materiais', icon: PackagePlus, permission: 'complementos', section: 'Estoque' },
  { name: 'Relatórios', href: '/relatorios', icon: BarChart3, permission: 'relatorios', section: 'Relatórios' },
  { name: 'Manutenção', href: '/relatorios-manutencao', icon: FileText, permission: 'relatorios_manutencao', section: 'Relatórios' },
  { name: 'Pesquisas', href: '/pesquisas', icon: Star, permission: 'pesquisas', section: 'Relatórios' },
  { name: 'Usuários', href: '/usuarios', icon: UserCog, permission: 'usuarios', section: 'Administração' },
  { name: 'Funções', href: '/funcoes', icon: Shield, permission: 'funcoes', section: 'Administração' },
  { name: 'Configurações', href: '/config', icon: Settings, permission: 'config', section: 'Administração' },
];

export const MENU_PERMISSIONS = [...new Set(NAV_ITEMS.map((item) => item.permission))];

export const MENU_PERMISSION_LABELS = Object.fromEntries(
  NAV_ITEMS.map((item) => [item.permission, item.name])
);
